// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__SsblI","left_side_container":"Footer_left_side_container__PvEyN","right_side_container":"Footer_right_side_container__8XVKq"};